var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7137 0.499962H2.27952C1.29738 0.499962 0.49939 1.30911 0.49939 2.30242V23.6975C0.49939 24.6908 1.29738 25.5 2.27952 25.5H23.7137C24.6958 25.5 25.4994 24.6908 25.4994 23.6975V2.30242C25.4994 1.30911 24.6958 0.499962 23.7137 0.499962ZM8.05519 21.9285H4.34984V9.99773H8.06077V21.9285H8.05519ZM6.20251 8.36827C5.0139 8.36827 4.05408 7.40286 4.05408 6.21983C4.05408 5.03679 5.0139 4.07139 6.20251 4.07139C7.38555 4.07139 8.35095 5.03679 8.35095 6.21983C8.35095 7.40844 7.39113 8.36827 6.20251 8.36827ZM21.9447 21.9285H18.2393V16.125C18.2393 14.741 18.2114 12.9609 16.3141 12.9609C14.3833 12.9609 14.0876 14.4676 14.0876 16.0245V21.9285H10.3822V9.99773H13.9369V11.6272H13.9871C14.4838 10.6897 15.6947 9.70197 17.4972 9.70197C21.2472 9.70197 21.9447 12.1741 21.9447 15.3884V21.9285Z",
    fill: "#918E9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.4974731d6dac6c41a303e367f035b8be.svg";
export { ForwardRef as ReactComponent };